/* DalBam v2 — hareket ve sepet (2026-09-27, taslak tema).
   Kitaplık: yalnızca temada zaten bulunan swiper-bundle.min.js (MIT), o da yalnızca
   ürün şeridi olan sayfada yüklenir. Swiper yüklenemezse şerit yerel kaydırmayla çalışır. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Panel görsellerinin perde gibi açılması */
  function initReveal() {
    var els = document.querySelectorAll('.v2-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Ürün şeridi */
  function initRails() {
    document.querySelectorAll('[data-v2-rail]').forEach(function (rail) {
      var track = rail.querySelector('.v2-rail__track');
      var bar = rail.querySelector('.v2-rail__progress i');
      var touched = function () { rail.classList.add('is-touched'); };
      var setBar = function (p, visible) {
        if (!bar) return;
        bar.style.width = Math.max(12, visible * 100) + '%';
        bar.style.transform = 'translateX(' + (p * (100 / Math.max(visible, 0.12) - 100)) + '%)';
      };
      if (window.Swiper && !reduce) {
        rail.classList.add('is-swiper');
        var container = rail.querySelector('.swiper');
        var sw = new window.Swiper(container, {
          slidesPerView: 1.16, spaceBetween: 12, speed: 700, grabCursor: true,
          breakpoints: { 700: { slidesPerView: 2.2 }, 1100: { slidesPerView: 3.25, spaceBetween: 16 } },
          navigation: { prevEl: rail.querySelector('[data-prev]'), nextEl: rail.querySelector('[data-next]') }
        });
        var visible = function () { return Math.min(1, sw.params.slidesPerView / sw.slides.length); };
        sw.on('progress', function (s, p) { setBar(p, visible()); });
        sw.on('touchStart', touched); sw.on('slideChange', touched);
        setBar(0, visible());
      } else if (track) {
        track.addEventListener('scroll', function () {
          touched();
          var max = track.scrollWidth - track.clientWidth;
          setBar(max > 0 ? track.scrollLeft / max : 0, track.clientWidth / track.scrollWidth);
        }, { passive: true });
        setBar(0, track.clientWidth / Math.max(track.scrollWidth, 1));
      }
    });
  }

  /* Sepet sayfası: adet, kaldır, "rutini tamamla" ekle */
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  function initCart() {
    var cart = document.querySelector('[data-v2-cart]');
    if (!cart) return;
    var busy = function () { cart.classList.add('is-busy'); };
    var fail = function () { cart.classList.remove('is-busy'); var e = cart.querySelector('[data-v2-cart-error]'); if (e) e.hidden = false; };
    var reload = function () { window.location.reload(); };

    cart.querySelectorAll('[data-v2-line]').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-v2-line'), 10);
      var input = row.querySelector('input');
      var set = function (q) { busy(); post('/cart/change.js', { line: line, quantity: q }).then(reload).catch(fail); };
      row.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
          set(q);
        });
      });
      if (input) input.addEventListener('change', function () { set(Math.max(0, parseInt(input.value, 10) || 0)); });
    });

    cart.querySelectorAll('[data-v2-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        busy();
        post('/cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-v2-add'), 10), quantity: 1 }] }).then(reload).catch(fail);
      });
    });
  }

  function start() { initReveal(); initRails(); initCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
